(() => {
  'use strict';

  if (window.__twCartReleaseFixV1) return;
  window.__twCartReleaseFixV1 = true;

  const bind = () => {
    document.querySelectorAll('[data-cart-form]').forEach((form) => {
      if (form.dataset.releaseConsentBound === 'true') return;
      form.dataset.releaseConsentBound = 'true';

      form.addEventListener('submit', (event) => {
        const submitter = event.submitter;
        const isCheckout =
          !submitter ||
          submitter.matches?.('[data-checkout-button]') ||
          submitter.getAttribute?.('name') === 'checkout';

        if (!isCheckout) return;

        const requiredInputs = [...form.querySelectorAll('[data-required-consent-input]')];
        if (requiredInputs.some((input) => !input.checked)) return;

        const timestamp = form.querySelector('[data-consent-timestamp]');
        if (timestamp && !timestamp.value) timestamp.value = new Date().toISOString();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();
